import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { CultureTextModel } from '../form';

export interface EmbeddedPhotoFieldModel extends BaseFieldModel {
  defaultValue: CultureTextModel[] | string;
  alt: CultureTextModel[] | string;
  type: FieldType.EmbeddedPhoto;
}

export class EmbeddedPhotoField extends BaseField implements EmbeddedPhotoFieldModel {
  public defaultValue: CultureTextModel[] | string = '';
  public alt: CultureTextModel[] | string = '';
  public type: FieldType.EmbeddedPhoto = FieldType.EmbeddedPhoto;

  constructor(cultures: string[]) {
    super(FieldType.EmbeddedPhoto, cultures);

    this.defaultValue = [];
    this.alt = [];
    for (const culture of cultures) {
      this.defaultValue.push({ culture, value: '' });
      this.alt.push({ culture, value: '' });
    }
  }
}
